// src/i18n/es/scope.ts
// Multi-hotel scope selector (mockup 05, callout 7 / Decision 6).
export const scope = {
  pill: {
    all: 'Todos los hoteles',
    one: '1 hotel',
    many: '%{count} hoteles',
    ofTotal: '%{count} de %{total} hoteles',
  },
  search: {
    placeholder: 'Buscar hotel…',
  },
  group: {
    allHotels: 'todos los hoteles',
  },
  footer: {
    selectedCount: '%{count} seleccionado |||| %{count} seleccionados',
    all: 'Todos',
    clear: 'Desmarcar todos',
    pickOne: 'Marque al menos un hotel',
  },
  remembered: 'La selección se recuerda por usuario.',
};

export default scope;
